import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export function UserProfile() {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();

  const imgURL = process.env.REACT_APP_BASE_IMGURL || "http://localhost:5409";

  console.log("UserProfile: Render", { user, isAuthenticated });

  if (!isAuthenticated || !user || !user.CustUUID) {
    console.log("UserProfile: No user or not authenticated", {
      user,
      isAuthenticated,
    });
    return (
      <div className="UserProfile" onClick={() => navigate("/app/account")}>
        <img src={`${imgURL}/default-profile.png`} alt="Default Profile" />
        <p>
          <strong>Loading...</strong>
          <span>N/A</span>
        </p>
      </div>
    );
  }

  return (
    <div className="UserProfile" onClick={() => navigate("/app/account")}>
      <img
        src={`${imgURL}/userfiles/${user.CustUUID}/${
          user.ProfilePic || "default-profile.png"
        }`}
        alt={`${user.FirstName || "User"} ${user.LastName || ""}`}
        onError={(e) => (e.target.src = `${imgURL}/default-profile.png`)}
      />
      <p>
        <strong>
          {user.FirstName || "User"} {user.LastName || ""}
        </strong>
        <span>
          {user.City || "N/A"}, {user.Province || "N/A"}
        </span>
      </p>
    </div>
  );
}
